(ns ycweb.app.website.voucher.balance-show
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.transitions :as t]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc voucher-balance-show < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        {:voucher/keys [remaining expires-on percentage minordersize limit-msg subscriptiononly] :as feedback}
        (cmn/curact voucher-atom :feedback)

        title
        (cond
          (not (zero? percentage))
          (str "Your Voucher is worth " (trf/topercentage (* percentage 100)) "% off")

          :else
          (str "Your Voucher balance is R" (u/currency-format (* remaining 100) 2)))]
    [:<>
     [:div
      {:class (u/bem :yc-page-content [:standard])}
      [:div
       {:class (u/bem :yc-section [:medium-underline])}
       [:div.yc-intro-text
        (headings/heading title
          {:type :h1
           :size :large
           :center true})
        (when (> minordersize 0)
          (feedback/feedback :info ""
            ["Your order must be worth more than R" minordersize " to use this voucher."]))
        (when (:campaign/store_only feedback)
          (feedback/feedback :info ""
            ["This is a Store Voucher and cannot be redeemed online.
              Please visit one of " [:a (urlstate/href-props app-atom "store-directory") "our stores"] "."]))
        (when limit-msg
          (feedback/feedback :info ""
            [limit-msg (when subscriptiononly " and only for a subscription")]))
        [:p.yc-paragraph
         "You can "
         [:a.text-link
          {:href "/index.htm?ref=voucherbalancepage"}
          "use it while shopping online now"]
         " or save the voucher for later. Once you've added products to your Cart, simply enter your voucher code at Checkout. "
         [:a
          {:href "/help.htm?action=article&id=52"
           :class (u/bem :text-link [:muted])}
          "Find out more."]]
        [:p.yc-paragraph
         [:b "Please note:"]
         (str " Your voucher is valid until " (ud/date-format expires-on "dd MMM YYYY") ".")]
        [:div.u-block-center.u-max-width-480
         [:div.flex-grid-group
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Start Shopping"
              {:href "/index.htm?ref=voucherbalancepage"
               :style :primary
               :size :default
               :full true})]]
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Terms & Conditions"
              {:href "/help.htm?action=article&id=119"
               :style :secondary
               :size :default
               :full true})]]]]]
       [:p
        {:class (u/bem :yc-paragraph [:small] :u-text-center)}
        [:b
         [:a
          {:on-click #(scroll/scroll-to-id % "yuppiechef-intro")
           :class (u/bem :text-link [:muted])}
          "New to Yuppiechef?"]]
        [:span.u-pipe "|"]
        [:a
         (merge
           (urlstate/href-props app-atom "gift-vouchers" "")
           {:class (u/bem :text-link [:muted])})
         "Want to buy a Gift Voucher?"]
        [:span.u-pipe "|"]
        [:a
         (merge
           (urlstate/href-props app-atom "gift-vouchers" "balance"
             {:scroll true})
           {:class (u/bem :text-link [:muted])})
         "Check another voucher"]]]
      [:div
       {:id "yuppiechef-intro"
        :class (u/bem :yc-section [:medium])}
       [:article.callout-panel
        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__hero
            [:div.u-max-width-490
             (web-common/lazy-image app-atom
               "pages/content-blocks/yuppiechef-product-range-490-retina"
               {:class ["yc-simple-image  yc-simple-image--full  yc-simple-image--shadow"]}
               {:w 490
                :q "auto"
                :alt "Yuppiechef Kitchen and Homeware Range"})]]]]
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__content
            (headings/heading "More About Yuppiechef"
              {:type :h2
               :size :medium})
            [:p.callout-panel__description
             "We stock over 8,900 products from 700 of the world's leading brands. From knives, cookware and appliances, to soft furnishings, craft spirits and the finest ingredients; we've sourced, tried and tested the best quality products we can find."]]]]]]]
      [:div
       {:class (u/bem :yc-section [:medium])}
       [:article.callout-panel
        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__content
            (headings/heading "Did You Know?"
              {:type :h2
               :size :medium})
            [:p.callout-panel__description
             "You can create and send someone a Yuppiechef Gift Voucher instantly by email or choose to print it at home as a card. Over 40 designs from which to choose."]
            (buttons/button-web "Create a Gift Voucher"
              (merge
                (urlstate/href-props app-atom "gift-vouchers" "")
                {:style :secondary
                 :size :default}))]]]
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__hero
            [:div.u-max-width-490
             (web-common/lazy-image app-atom
               "pages/content-blocks/yuppiechef-gift-vouchers-489"
               {:class ["yc-simple-image  yc-simple-image--full"]}
               {:w 490
                :q "auto"
                :alt "Yuppiechef Gift Vouchers"})]]]]]]]
      [:div
       {:class (u/bem :yc-section [:large])}
       [:article.callout-panel
        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__hero
            [:div.u-max-width-490
             (web-common/lazy-image app-atom
               "pages/content-blocks/yuppiechef-customer-service-and-delivery-490-retina"
               {:class ["yc-simple-image  yc-simple-image--full  yc-simple-image--shadow"]}
               {:w 490
                :q "auto"
                :alt "Yuppiechef Customer Service and Delivery"})]]]]
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__content
            (headings/heading "Simple & Safe Shopping"
              {:type :h2
               :size :medium})
            [:p.callout-panel__description
             "Paying on Yuppiechef.com is simple and secure and we deliver by courier throughout South Africa. Our dedicated customer service team is also here to help you every step of the way, you're in good hands."]]]]]]]
      [:div
       {:class (u/bem :yc-section [:large])}
       [:div.u-block-center.u-max-width-240
        (buttons/button-web "Start Shopping"
          {:href "/index.htm?ref=voucherbalancepage"
           :style :primary
           :size :default
           :full true})]]]]))

(defmethod flow/render-screen :web.gift-vouchers/balance-show [app-atom _]
  (website/screen-wrapper app-atom
    (voucher-balance-show app-atom)
    {}))

(defmethod t/transition-open :web.gift-vouchers/balance-show [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)]
    (when
      (nil? (cmn/curact process-atom :voucher))
      (urlstate/redirect app-atom "gift-vouchers" "balance" {}))))